import { PartialTranslation } from '../translations';

export const ta: PartialTranslation = {
  newChat: 'புதிய அரட்டை',
  search: 'தேடு',
  user: 'பயனர்',
  settings: 'அமைப்புகள்',
  language: 'மொழி',
  getHelp: 'உதவி பெறுங்கள்',
  viewAllPlans: 'அனைத்து திட்டங்களையும் பார்க்கவும்',
  learnMore: 'மேலும் அறியவும்',
  logOut: 'வெளியேறு',
  chooseLanguage: 'மொழியைத் தேர்ந்தெடுக்கவும்',
  chooseYourPreferredLanguage: 'உங்கள் விருப்பமான மொழியைத் தேர்ந்தெடுக்கவும்',
  searchLanguages: 'மொழிகளைத் தேடுங்கள்...',
  autoDetect: 'தானியங்கி கண்டறிதல்',
  noLanguagesFound: 'மொழிகள் எதுவும் கிடைக்கவில்லை',
  askAnything: 'எதையும் கேளுங்கள்',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'தனிப்பட்ட',
  freePlan: 'இலவச திட்டம்',
  current: 'தற்போதைய',
  close: 'மூடு',
  archive: 'காப்பகம்',
  delete: 'நீக்கு',
  confirmDelete: 'இந்த அரட்டையை நீக்க விரும்புகிறீர்களா?',
  confirmArchive: 'இந்த அரட்டையை காப்பகப்படுத்த விரும்புகிறீர்களா?',
  deleteCannotUndo: 'இந்த செயலை மாற்ற முடியாது.',
  archiveCanFind: 'காப்பகப்படுத்திய பிறகு காப்பக பட்டியலில் கண்டுபிடிக்கலாம்.',
  // 资源面板
  resources: 'வளங்கள்',
  addResource: 'வளம் சேர்க்கவும்',
  deleteResource: 'வளம் நீக்கவும்',
  noMatchingResourcesFound: 'பொருத்தமான வளங்கள் இல்லை',
  noResourcesAvailable: 'வளங்கள் கிடைக்கவில்லை',
  hideResources: 'வளங்களை மறைக்கவும்',
  showResources: 'வளங்களைக் காட்டவும்',
  
  // 聊天输入框
  typeMessage: 'செய்தி தட்டச்சு செய்யவும்...',
  thinkingOptions: 'சிந்தனை விருப்பங்கள்',
  deleteFile: 'கோப்பை நீக்கவும்',
  clearSelection: 'தேர்வை அழிக்கவும்',
  
  // 思考模式选项
  deepInsight: 'ஆழமான நுண்ணறிவு · மேற்பரப்பு பகுப்பாய்வு',
  deepInsightDesc: 'முக்கிய புள்ளிகளின் விரைவான புரிதல்',
  deepExploration: 'ஆழமான ஆய்வு · விரிவான பகுப்பாய்வு',
  deepExplorationDesc: 'பல பரிமாண ஆழமான ஆராய்ச்சி',
  deepDeconstruction: 'ஆழமான சிதைவு · முறையான வாதம்',
  deepDeconstructionDesc: 'அடுக்கு வாரியான முற்போக்கான பகுப்பாய்வு',
  
  // 写作模式选项
  contractReview: 'ஒப்பந்த மதிப்பாய்வு · ஆபத்து அடையாளம்',
  contractReviewDesc: 'உட்பிரிவு பகுப்பாய்வு மற்றும் இணக்க சரிபார்ப்பு',
  textPolish: 'உரை மெருகூட்டல் · தொழில்முறை வெளிப்பாடு',
  textPolishDesc: 'மொழி உகப்பாக்கம் மற்றும் கட்டமைப்பு சரிசெய்தல்',
  legalDocuments: 'சட்ட ஆவணங்கள் · நிலையான வரைவு',
  legalDocumentsDesc: 'தொழில்முறை சட்ட ஆவண எழுத்து',
  addAttachment: 'இணைப்பு சேர்க்கவும்',
  sendMessage: 'செய்தி அனுப்பவும்',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'உள்நுழைக',
  register: 'பதிவு செய்க',
  welcomeBack: 'LawHelper-க்கு வரவேற்கிறோம்',
  loginSubtitle: 'உங்கள் AI சட்ட ஆராய்ச்சி உதவியாளர்',
  continueWithGoogle: 'Google உடன் தொடரவும்',
  continueWithMicrosoft: 'Microsoft உடன் தொடரவும்',
  continueWithWeChat: 'WeChat உடன் தொடரவும்',
  orContinueWith: 'அல்லது இதனுடன் தொடரவும்',
  emailTab: 'மின்னஞ்சல்',
  phoneTab: 'தொலைபேசி',
  emailPlaceholder: 'உங்கள் மின்னஞ்சலை உள்ளிடவும்',
  phonePlaceholder: 'தொலைபேசி எண்ணை உள்ளிடவும்',
  codePlaceholder: '6 இலக்க குறியீட்டை உள்ளிடவும்',
  sending: 'அனுப்புகிறது...',
  verifying: 'சரிபார்க்கிறது...',
  verify: 'சரிபார்',
  sendMagicLink: 'மேஜிக் இணைப்பை அனுப்பு',
  getVerificationCode: 'குறியீடு பெறு',
  resendCode: 'குறியீட்டை மீண்டும் அனுப்பு',
  resendIn: 'மீண்டும் அனுப்பு',
  magicLinkSent: 'மேஜிக் இணைப்பு உங்கள் மின்னஞ்சலுக்கு அனுப்பப்பட்டது',
  magicLinkHint: 'உங்கள் மின்னஞ்சலுக்கு ஒரு பாதுகாப்பான இணைப்பை அனுப்புவோம்',
  otpSent: 'சரிபார்ப்பு குறியீடு அனுப்பப்பட்டது',
  agreeToTerms: 'தொடர்வதன் மூலம், நீங்கள் ஒப்புக்கொள்கிறீர்கள்',
  privacyPolicy: 'தனியுரிமை கொள்கை',
  termsOfService: 'சேவை விதிமுறைகள்',
  and: 'மற்றும்',
  privacyTitle: 'உங்கள் தனியுரிமை முக்கியமானது',
  privacyIntro: 'சிறந்த அனுபவத்தை வழங்க குக்கீகள் மற்றும் ஒத்த தொழில்நுட்பங்களைப் பயன்படுத்துகிறோம்.',
  essentialCookies: 'அத்தியாவசிய குக்கீகள்',
  essentialDesc: 'இணையதளம் செயல்பட தேவை',
  analyticsCookies: 'பகுப்பாய்வு குக்கீகள்',
  analyticsDesc: 'சேவையை மேம்படுத்த உதவுகிறது',
  marketingCookies: 'சந்தைப்படுத்தல் குக்கீகள்',
  marketingDesc: 'தனிப்பயன் உள்ளடக்கத்திற்கு பயன்படுத்தப்படுகிறது',
  acceptAll: 'அனைத்தையும் ஏற்கவும்',
  essentialOnly: 'அத்தியாவசியமானவை மட்டும்',
  customize: 'தனிப்பயனாக்கு',
  savePreferences: 'விருப்பங்களை சேமி',
  back: 'பின்னால்',
  readPrivacyPolicy: 'எங்கள் தனியுரிமை கொள்கையைப் படிக்கவும்',
  cookiePolicy: 'குக்கீ கொள்கை',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI மதிப்பாய்வு',
  aiDraft: 'AI வரைவு',
  smartAssistant: 'வார்ப்புரு',

  // 知识库搜索
  enableKnowledgeSearch: 'தேடலை இயக்கு',
  knowledgeSearchDesc: 'AI உங்கள் ஆவணங்களில் தேடுகிறது',
  clickToDisable: 'முடக்கு',
  clickToEnable: 'இயக்கு',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Close Resources Panel',
  uploading: 'Uploading %{fileName}...',
  processing: 'Processing %{fileName}...',
  uploadSuccess: '✓ %{fileName} uploaded successfully',
  uploadError: '✗ Upload failed: %{error}',
  quickAnswer: 'விரைவான பதில்',
  quickAnswerDesc: 'Fast response for simple questions',
  cancelRequest: 'ரத்து செய்',
  library: 'நூலகம்',
  filterAll: 'அனைத்தும்',
  filterChat: 'Chats',
  filterReview: 'Review',
  filterDraft: 'Draft',
  filterTemplate: 'Template',
  filterForm: 'Form',
  thinking: 'சிந்திக்கிறது...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Service Error',
  uploaded: 'Uploaded',
  settingsGeneral: 'பொதுவான',
  settingsNotifications: 'Notifications',
  settingsAppearance: 'Appearance',
  settingsProfile: 'Profile',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Color Mode',
  settingsLight: 'Light',
  settingsDark: 'Dark',
  settingsSystem: 'System',
  about: 'பற்றி',
  reviewTitle: 'Document Review',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Reviewing...',
  reviewComplete: 'Review Complete',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Legal Document Drafting',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generating...',
  generatedSuccess: '✅ Document generated! You can view and edit in the editor.',
  drafterWelcome: 'Welcome to AI Document Assistant',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Examples:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Describe your document needs...',
  drafterThinking: 'Thinking...',
  drafterHistoryTitle: 'History',
  drafterNoHistory: 'No history yet',
  drafterNewChat: 'New Chat',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Save Document',
  drafterDownload: 'Download Document',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Exit',
  drafterConfirm: 'Confirm',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI Workflow',
  workflowRunning: 'Running...',
  workflowReady: 'Ready',
  workflowCompleted: 'Completed',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Accept Changes',
  rejectChanges: 'Reject Changes',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Stop',
  restartWorkflow: 'Restart',
  startDrafting: 'Start Drafting',
  interrupt: 'Stop',
  documentSubject: 'Document Subject *',
  documentType: 'Document Type',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contract',
  docTypeAgreement: 'Agreement',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Letter',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'China',
  countryUSA: 'United States',
  countryGermany: 'Germany',
  countryJapan: 'Japan',
  countryFrance: 'France',
  countryUK: 'United Kingdom',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'ஸ்மார்ட் ஆவண உதவியாளர்',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Select File',
  smartDocOr: 'or',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'பிழை',
  unknownError: 'Unknown error',
  file: 'கோப்பு',
  loading: 'ஏற்றுகிறது...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI பகுப்பாய்வு',
};
